import { render, staticRenderFns } from "./accountCard.vue?vue&type=template&id=354989b1"
import script from "./accountCard.vue?vue&type=script&lang=js"
export * from "./accountCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports